// Mapeo de nombres de regiones: nombre mostrado en selector → nombre en Shopify
const regionShopifyMap = {
  "Región Metropolitana": "Santiago",
  "O'Higgins": "O'Higgins",
  "Araucanía": "Araucanía",
  "Aysén": "Aysén",
  "Magallanes": "Magallanes",
  // Las demás regiones tienen el mismo nombre
  "Arica y Parinacota": "Arica y Parinacota",
  "Tarapacá": "Tarapacá",
  "Antofagasta": "Antofagasta",
  "Atacama": "Atacama",
  "Coquimbo": "Coquimbo",
  "Valparaíso": "Valparaíso",
  "Maule": "Maule",
  "Ñuble": "Ñuble",
  "Biobío": "Biobío",
  "Los Ríos": "Los Ríos",
  "Los Lagos": "Los Lagos"
};

// Función para obtener el nombre de región que Shopify espera
function getShopifyRegionName(regionName) {
  return regionShopifyMap[regionName] || regionName;
}

// Regiones y comunas de Chile 2025 - con nombres cortos y claros
const regionesComunas = {
  "Arica y Parinacota": ["Arica", "Camarones", "General Lagos", "Putre"],
  "Tarapacá": ["Alto Hospicio", "Camiña", "Colchane", "Huara", "Iquique", "Pica", "Pozo Almonte"],
  "Antofagasta": ["Antofagasta", "Calama", "María Elena", "Mejillones", "Ollagüe", "San Pedro de Atacama", "Sierra Gorda", "Taltal", "Tocopilla"],
  "Atacama": ["Alto del Carmen", "Caldera", "Chañaral", "Copiapó", "Diego de Almagro", "Freirina", "Huasco", "Tierra Amarilla", "Vallenar"],
  "Coquimbo": ["Andacollo", "Canela", "Combarbalá", "Coquimbo", "Illapel", "La Higuera", "La Serena", "Los Vilos", "Monte Patria", "Ovalle", "Paiguano", "Punitaqui", "Río Hurtado", "Salamanca", "Vicuña"],
  "Valparaíso": ["Algarrobo", "Cabildo", "Calera", "Calle Larga", "Cartagena", "Casablanca", "Catemu", "Concón", "El Quisco", "El Tabo", "Hijuelas", "Isla de Pascua", "Juan Fernández", "La Cruz", "La Ligua", "Limache", "Llaillay", "Los Andes", "Nogales", "Olmué", "Panquehue", "Papudo", "Petorca", "Puchuncaví", "Putaendo", "Quillota", "Quilpué", "Quintero", "Rinconada", "San Antonio", "San Esteban", "San Felipe", "Santa María", "Santo Domingo", "Valparaíso", "Villa Alemana", "Viña del Mar", "Zapallar"],
  "Región Metropolitana": ["Alhué", "Buin", "Calera de Tango", "Cerrillos", "Cerro Navia", "Colina", "Conchalí", "Curacaví", "El Bosque", "El Monte", "Estación Central", "Huechuraba", "Independencia", "Isla de Maipo", "La Cisterna", "La Florida", "La Granja", "La Pintana", "La Reina", "Lampa", "Las Condes", "Lo Barnechea", "Lo Espejo", "Lo Prado", "Macul", "Maipú", "María Pinto", "Melipilla", "Ñuñoa", "Padre Hurtado", "Paine", "Pedro Aguirre Cerda", "Peñaflor", "Peñalolén", "Pirque", "Providencia", "Pudahuel", "Puente Alto", "Quilicura", "Quinta Normal", "Recoleta", "Renca", "San Bernardo", "San Joaquín", "San José de Maipo", "San Miguel", "San Pedro", "San Ramón", "Santiago", "Talagante", "Tiltil", "Vitacura"],
  "O'Higgins": ["Chépica", "Chimbarongo", "Codegua", "Coinco", "Coltauco", "Doñihue", "Graneros", "La Estrella", "Las Cabras", "Litueche", "Lolol", "Machalí", "Malloa", "Marchihue", "Nancagua", "Navidad", "Olivar", "Palmilla", "Paredones", "Peralillo", "Peumo", "Pichidegua", "Pichilemu", "Placilla", "Pumanque", "Quinta de Tilcoco", "Rancagua", "Rengo", "Requínoa", "San Fernando", "San Vicente de Tagua Tagua", "Santa Cruz"],
  "Maule": ["Cauquenes", "Chanco", "Colbún", "Constitución", "Curepto", "Curicó", "Empedrado", "Hualañé", "Licantén", "Linares", "Longaví", "Maule", "Molina", "Parral", "Pelarco", "Pelluhue", "Pencahue", "Rauco", "Retiro", "Río Claro", "Romeral", "Sagrada Familia", "San Clemente", "San Javier", "San Rafael", "Talca", "Teno", "Vichuquén", "Villa Alegre", "Yerbas Buenas"],
  "Ñuble": ["Bulnes", "Chillán", "Chillán Viejo", "Cobquecura", "Coelemu", "Coihueco", "El Carmen", "Ninhue", "Ñiquén", "Pemuco", "Pinto", "Portezuelo", "Quillón", "Quirihue", "Ránquil", "San Carlos", "San Fabián", "San Ignacio", "San Nicolás", "Treguaco", "Yungay"],
  "Biobío": ["Alto Biobío", "Antuco", "Arauco", "Cabrero", "Cañete", "Chiguayante", "Concepción", "Contulmo", "Coronel", "Curanilahue", "Florida", "Hualpén", "Hualqui", "Laja", "Lebu", "Los Álamos", "Los Ángeles", "Lota", "Mulchén", "Nacimiento", "Negrete", "Penco", "Quilaco", "Quilleco", "San Pedro de la Paz", "San Rosendo", "Santa Bárbara", "Santa Juana", "Talcahuano", "Tirúa", "Tomé", "Tucapel", "Yumbel"],
  "Araucanía": ["Angol", "Carahue", "Cholchol", "Collipulli", "Cunco", "Curacautín", "Curarrehue", "Ercilla", "Freire", "Galvarino", "Gorbea", "Lautaro", "Loncoche", "Lonquimay", "Los Sauces", "Lumaco", "Melipeuco", "Nueva Imperial", "Padre Las Casas", "Perquenco", "Pitrufquén", "Pucón", "Purén", "Renaico", "Saavedra", "Temuco", "Teodoro Schmidt", "Toltén", "Traiguén", "Victoria", "Vilcún", "Villarrica"],
  "Los Ríos": ["Corral", "Futrono", "La Unión", "Lago Ranco", "Lanco", "Los Lagos", "Máfil", "Mariquina", "Paillaco", "Panguipulli", "Río Bueno", "Valdivia"],
  "Los Lagos": ["Ancud", "Calbuco", "Castro", "Chaitén", "Chonchi", "Cochamó", "Curaco de Vélez", "Dalcahue", "Fresia", "Frutillar", "Futaleufú", "Hualaihué", "Llanquihue", "Los Muermos", "Maullín", "Osorno", "Palena", "Puerto Montt", "Puerto Octay", "Puerto Varas", "Puqueldón", "Purranque", "Puyehue", "Queilén", "Quellón", "Quemchi", "Quinchao", "Río Negro", "San Juan de la Costa", "San Pablo"],
  "Aysén": ["Aysén", "Chile Chico", "Cisnes", "Cochrane", "Coyhaique", "Guaitecas", "Lago Verde", "O'Higgins", "Río Ibáñez", "Tortel"],
  "Magallanes": ["Antártica", "Cabo de Hornos", "Laguna Blanca", "Natales", "Porvenir", "Primavera", "Punta Arenas", "Río Verde", "San Gregorio", "Timaukel", "Torres del Paine"]
};

let isInitialized = false;

// Función para actualizar atributos del carrito
function updateChileCartAttributes(region, comuna, callback) {
  if (!region || !comuna) return;

  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      attributes: {
        'Región': region,
        'Comuna': comuna
      }
    })
  })
  .then(response => response.json())
  .then(data => {
    localStorage.setItem('chile_region', region);
    localStorage.setItem('chile_comuna', comuna);
    if (callback && typeof callback === 'function') {
      setTimeout(callback, 300);
    }
  })
  .catch(error => {
    if (callback && typeof callback === 'function') {
      setTimeout(callback, 300);
    }
  });
}

// Función para obtener costos de envío
function fetchShippingCosts(region, comuna) {
  const shippingWrapper = document.querySelector('.shipping-costs-wrapper');
  const shippingRates = document.getElementById('shipping-rates');

  if (!shippingWrapper || !shippingRates) return;

  // Verificar si jQuery está disponible
  if (typeof jQuery === 'undefined') {
    return;
  }

  // Convertir el nombre de la región al formato que Shopify espera
  const shopifyRegion = getShopifyRegionName(region);

  // Primero actualizar atributos del carrito, LUEGO obtener tarifas
  updateChileCartAttributes(region, comuna, function() {
    jQuery.get(
      "/cart/shipping_rates.json?shipping_address[country]=Chile"
      + "&shipping_address[province]=" + encodeURIComponent(shopifyRegion)
      + "&shipping_address[city]=" + encodeURIComponent(comuna)
      + "&shipping_address[zip]=",
      function (data) {
        const html = [];

        if (data.shipping_rates && data.shipping_rates.length > 0) {
          for (const index in data.shipping_rates) {
            const shipping_rate = data.shipping_rates[index];
            const price = parseFloat(shipping_rate.price);

            // Si el precio es 0, mostrar "Envío Gratis"
            let priceText;
            if (price === 0) {
              priceText = '<strong style="color: var(--success-color, #4caf50);">Envío Gratis</strong>';
            } else {
              priceText = new Intl.NumberFormat('es-CL', {
                style: 'currency',
                currency: 'CLP',
                minimumFractionDigits: 0
              }).format(price);
            }

            html.push(
              "<p>" + shipping_rate.presentment_name + ": " + priceText + "</p>"
            );
          }

          shippingRates.innerHTML = html.join("");
          shippingWrapper.style.display = 'block';
        } else {
          shippingRates.innerHTML = "<p>No hay tarifas de envío disponibles para esta zona.</p>";
          shippingWrapper.style.display = 'block';
        }
      }
    ).fail(function() {
      shippingRates.innerHTML = "<p>Error al obtener tarifas de envío.</p>";
      shippingWrapper.style.display = 'block';
    });
  });
}

function initChileRegiones() {
  const regionSelect = document.getElementById('chile-region');
  const comunaSelect = document.getElementById('chile-comuna');
  const errorElement = document.getElementById('location-error');

  if (!regionSelect || !comunaSelect) {
    return false;
  }

  // Si ya está inicializado y tiene regiones, no hacer nada
  if (regionSelect.dataset.initialized === 'true') {
    return true;
  }

  // Poblar regiones si no están pobladas (orden geográfico: norte a sur)
  if (regionSelect.options.length === 1) {
    Object.keys(regionesComunas).forEach(function(region) {
      const option = document.createElement('option');
      option.value = region;
      option.textContent = region;
      regionSelect.appendChild(option);
    });
  }

  // Marcar como inicializado
  regionSelect.dataset.initialized = 'true';

  // Agregar listener de cambio de región (solo si no existe)
  if (!regionSelect.dataset.hasListener) {
    regionSelect.addEventListener('change', function() {
      const comunaSelectCurrent = document.getElementById('chile-comuna');
      const errorElementCurrent = document.getElementById('location-error');
      const shippingWrapper = document.querySelector('.shipping-costs-wrapper');

      comunaSelectCurrent.innerHTML = '<option value="">Selecciona una comuna</option>';
      if (errorElementCurrent) errorElementCurrent.textContent = '';
      if (shippingWrapper) shippingWrapper.style.display = 'none';

      if (this.value) {
        comunaSelectCurrent.disabled = false;
        regionesComunas[this.value].sort().forEach(function(comuna) {
          const option = document.createElement('option');
          option.value = comuna;
          option.textContent = comuna;
          comunaSelectCurrent.appendChild(option);
        });
      } else {
        comunaSelectCurrent.disabled = true;
      }
    });
    regionSelect.dataset.hasListener = 'true';
  }

  // Agregar listener de cambio de comuna para mostrar costos de envío
  if (!comunaSelect.dataset.hasListener) {
    comunaSelect.addEventListener('change', function() {
      const regionValue = document.getElementById('chile-region').value;
      const comunaValue = this.value;

      if (regionValue && comunaValue) {
        fetchShippingCosts(regionValue, comunaValue);
      }
    });
    comunaSelect.dataset.hasListener = 'true';
  }

  // Validación al hacer checkout
  const cartForm = document.querySelector('.js-cart-form');
  if (cartForm && !cartForm.dataset.hasListener) {
    cartForm.addEventListener('submit', function(e) {
      if (document.activeElement && document.activeElement.name === 'checkout') {
        const regionVal = document.getElementById('chile-region').value;
        const comunaVal = document.getElementById('chile-comuna').value;
        const errorEl = document.getElementById('location-error');

        if (!regionVal || !comunaVal) {
          e.preventDefault();
          if (errorEl) {
            errorEl.textContent = 'Por favor selecciona región y comuna antes de continuar.';
            errorEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        } else {
          // Los datos se envían automáticamente como cart attributes
          // y estarán disponibles en el checkout sin necesidad de scripts adicionales
          localStorage.setItem('chile_region', regionVal);
          localStorage.setItem('chile_comuna', comunaVal);
        }
      }
    });
    cartForm.dataset.hasListener = 'true';
  }

  isInitialized = true;
  return true;
}

// Función para intentar inicializar múltiples veces
function tryInit(attempts) {
  attempts = attempts || 0;
  if (attempts > 10) return;

  if (!initChileRegiones() && attempts < 10) {
    setTimeout(function() {
      tryInit(attempts + 1);
    }, 300);
  }
}

// Inicializar cuando el DOM esté listo
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(tryInit, 500);
  });
} else {
  setTimeout(tryInit, 500);
}

// Escuchar eventos de drawer/modal del tema Mr Parker
document.addEventListener('slideout:open', function() {
  setTimeout(tryInit, 300);
});

document.addEventListener('modal:open', function() {
  setTimeout(tryInit, 300);
});

// También escuchar clics en elementos que abren el carrito
document.addEventListener('click', function(e) {
  const target = e.target;
  if (target && (
    target.classList.contains('js-ajax-submit') ||
    target.closest('.js-ajax-submit') ||
    target.classList.contains('cart-link') ||
    target.closest('.cart-link')
  )) {
    setTimeout(tryInit, 500);
  }
}, true);

// Re-inicializar cuando el carrito se actualice
if (typeof MutationObserver !== 'undefined') {
  const observer = new MutationObserver(function(mutations) {
    for (let mutation of mutations) {
      // Observar cuando se agregan nuevos nodos con los selectores
      if (mutation.addedNodes.length) {
        for (let node of mutation.addedNodes) {
          if (node.nodeType === 1 && (node.id === 'chile-region' || node.querySelector('#chile-region'))) {
            const regionSelect = document.getElementById('chile-region');
            if (regionSelect && regionSelect.dataset.initialized !== 'true') {
              setTimeout(tryInit, 200);
            }
            return;
          }
        }
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}
